<template>
    <div class="flex justify-content-center align-items-center" ref="container">
        <template v-if="loading">
            <ProgressSpinner :style="style" :strokeWidth="strokeWidth" :fill="fill" :animationDuration="animationDuration" />
        </template>
        <template v-else>
            <slot />
        </template>
    </div>
</template>
<script>
import ProgressSpinner from 'primevue/progressspinner';
export default {
    props:{
        loading: Boolean,
        strokeWidth: {
            type: String,
            default: '2'
        },
        fill: {
            type: String,
            default: 'none'
        },
        animationDuration: {
            type: String,
            default: '2s'
        }
    },
    components:{
        ProgressSpinner
    },
    watch:{
        loading(val){
            let width = this.$refs.container.clientWidth;
            let height = this.$refs.container.clientHeight;
            this.size = height;
            this.$refs.container.setAttribute("style", "width: "+width+"px;"+"height: "+height+"px;");
        }
    },
    data(){
        return{
            size: 20
        }
    },
    computed:{
        style(){
            return "width:"+this.size+"px;"+"height:"+this.size+"px;"
        }
    }
}
</script>
